import { connect } from 'react-redux';

import Browser from '../../components/sider/browser';

export default connect()(Browser);



// WEBPACK FOOTER //
// ./containers/sider/browser.js